export var HYPHEN = '-';
export var MINUS = '−';
export var PLUS = '+';
export var NBSP = "\xA0";
export var MAX_FRACTIONAL_DIGITS = 20;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9mb3JtYXR0ZXJzL3V0aWxzL2NvbnN0cy50cyJdLCJuYW1lcyI6WyJIWVBIRU4iLCJNSU5VUyIsIlBMVVMiLCJOQlNQIiwiTUFYX0ZSQUNUSU9OQUxfRElHSVRTIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLElBQU1BLE1BQU0sR0FBRyxHQUFmO0FBQ1AsT0FBTyxJQUFNQyxLQUFLLEdBQUcsR0FBZDtBQUNQLE9BQU8sSUFBTUMsSUFBSSxHQUFHLEdBQWI7QUFDUCxPQUFPLElBQU1DLElBQUksR0FBRyxNQUFiO0FBRVAsT0FBTyxJQUFNQyxxQkFBcUIsR0FBRyxFQUE5QiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBIWVBIRU4gPSAnLSc7XG5leHBvcnQgY29uc3QgTUlOVVMgPSAn4oiSJztcbmV4cG9ydCBjb25zdCBQTFVTID0gJysnO1xuZXhwb3J0IGNvbnN0IE5CU1AgPSAnXFx1MDBhMCc7XG5cbmV4cG9ydCBjb25zdCBNQVhfRlJBQ1RJT05BTF9ESUdJVFMgPSAyMDtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/formatters/utils/consts.js
// module id = 491
// module chunks = 118